import React from "react";
import DeviceRouter from "../official_website_new/shared/DeviceRouter";

/**
 * 继续走 official_website 入口与官方 URL（/official_website.html），
 * 实际呈现为 official_website_new 落地页（含设备分发：PC ↔ Mobile）。
 * 旧版实现仍保留在 ./index.jsx 等文件中。
 */
export default function App() {
  return <DeviceRouter />;
}